import React from 'react';
import {v4 as uuid} from 'uuid';
import {useDispatch, useSelector} from "react-redux";
import {
    setAnswer,
    setAskedQuestion,
    setAvatarMuted,
    setChatAnswers,
    setComputingId,
    setFirstQuestionAsked,
    setGenerating,
    setIsChatMode,
    setQnToSend,
    setStreamStatus,
    setWelcomeVideoPlay
} from "../store/reducers/questionReducer";
import SpeechRecognition, {useSpeechRecognition} from 'react-speech-recognition';
import {Example} from './Example';
import { config } from '../config';

interface IProps {
    sendDataToSocket: (data: any) => void;
}

interface ProfileQuestionRequest {
    query: string;
    question_uid: string;
    response_type: string,
    client: string;
    request_id: string;
    chat_history: any;
    name: string;
    job_title: string;
    bio: string;
    profile_prompt?: string;
    investor_name?: string;
    investor_email?: string;
    thread_id?: string;
    type?: string;
    assistant_id?: string;
    version?: string
}

export const Question = (props: IProps) => {
    const {sendDataToSocket} = props
    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition,
        interimTranscript,
        finalTranscript,
        isMicrophoneAvailable
    } = useSpeechRecognition();

    const [typed, setTyped] = React.useState<string>('');
    const [speech, setSpeech] = React.useState<boolean>(false);
    const [finalTimeoutId, setFinalTimeoutId] = React.useState<any>(null);
    const [isPaused, setIsPaused] = React.useState<boolean>(false);

    const textareaRef = React.useRef<any>(null);

    const chatAnswers = useSelector((state: any) => state.questionReducer.chatAnswers);
    const profilePath = useSelector((state: any) => state.questionReducer.profilePath);
    const bio = useSelector((state: any) => state.questionReducer.bio);
    const name = useSelector((state: any) => state.questionReducer.name);
    const jobTitle = useSelector((state: any) => state.questionReducer.role);
    const computingId = useSelector((state: any) => state.questionReducer.computingId);
    const generating = useSelector((state: any) => state.questionReducer.generating);
    const suggestedQuestions = useSelector((state: any) => state.questionReducer.suggestedQuestions);
    const qnToSend = useSelector((state: any) => state.questionReducer.qnToSend);
    const firstName = useSelector((state: any) => state.questionReducer.firstName);
    const vectorStoreId = useSelector((state: any) => state.questionReducer.vectorStoreId);
    const threadId = useSelector((state: any) => state.questionReducer.threadId);

    const dispatch = useDispatch();


    let answerData: any = [];

    React.useEffect(() => {
        // When listening stops, start a 2-second timer
        if (!listening && isPaused) {
            const timeoutId = setTimeout(() => {
                askQuestion(typed);
                setIsPaused(false); // Reset paused state
                resetTranscript(); // Reset the transcript after handling the finalTranscript
            }, 2000);

            // Save timeoutId to state to potentially clear it later
            setFinalTimeoutId(timeoutId);
        }
    }, [listening, isPaused, finalTranscript, resetTranscript]);

    React.useEffect(() => {
        // If user starts talking again before the 2-second timer is up, clear the timer
        if (listening && finalTimeoutId) {
            clearTimeout(finalTimeoutId);
            setFinalTimeoutId(null);
            setIsPaused(false); // Reset paused state
        }
    }, [listening, finalTimeoutId]);

    // Cleanup on unmount
    React.useEffect(() => {
        return () => {
            if (finalTimeoutId) {
                clearTimeout(finalTimeoutId);
            }
        };
    }, [finalTimeoutId]);

    React.useEffect(() => {
        setTyped(transcript);
    }, [transcript])
    React.useEffect(() => {
        if (qnToSend !== '') {
            askQuestion(qnToSend);
            dispatch(setQnToSend(""));
        }
    }, [qnToSend])

    /*React.useEffect(() => {
        (async () => {
            if (finalTranscript) {
                askQuestion(typed);
            }
        })();

        return () => {
        };
    }, [finalTranscript])*/


    function sendQuestion() {
        askQuestion(typed);
    }

    function askQuestion(e: any) {
        if (computingId == '') {
            dispatch(setIsChatMode(true));
            dispatch(setWelcomeVideoPlay(false));
            dispatch(setFirstQuestionAsked(true))
            answerData = [];
            dispatch(setAskedQuestion(true));

            //dispatch(setReady(false))
            let divText = e;
            if (typeof e !== 'string') {
                // divText = e.target.textContent;
                divText = typed;
            } else {
                setTyped(e);
            }

            if (divText?.trim() === '') {
                return;
            }
            let questionId: string = uuid();
            let requestUID: string = uuid();
            dispatch(setComputingId(questionId));
            dispatch(setGenerating(questionId));
            dispatch(setStreamStatus('Computing'));
            let requestData:ProfileQuestionRequest = {
                query: divText,
                    question_uid: questionId,
                    response_type: 'profile-question',
                    client: profilePath,
                    request_id: requestUID,
                    chat_history: chatAnswers,
                    name,
                    job_title: jobTitle,
                    bio,
            };
            if(vectorStoreId && threadId) {
                 requestData.response_type = 'assistant-message';
                 requestData.thread_id = threadId;
                 requestData.type = "genything-profile";
                 requestData.assistant_id = config.assistantId;
                 requestData.version = "azure";
                 requestData.query = `User question:${divText} \n\nName:${name} \n\nJob Title:${jobTitle} \n\nBio: ${bio}`
            } 
            
            if ((window as any).profilePrompt && (window as any).profilePrompt != '') {
                requestData.profile_prompt = (window as any).profilePrompt ? (window as any).profilePrompt : '';

            }
            if ((window as any).isOwner === false && (window as any).investorName && (window as any).investorName != '') {
                requestData.investor_name = (window as any).investorName ? (window as any).investorName : '';
                requestData.investor_email = (window as any).investorEmail ? (window as any).investorEmail : '';
            }


            sendDataToSocket(JSON.stringify(requestData));
            setTimeout(() => {
                sendDataToSocket(JSON.stringify({
                    query: divText,
                    question_uid: questionId,
                    response_type: 'profile-slide',
                    client: profilePath,
                    request_id: requestUID,
                    chat_history: chatAnswers,
                    name,
                    job_title: jobTitle,
                    bio
                }));
            }, 500)
            setTyped('')
            let chatAnswer = {
                query: divText,
                type: 'myself',
                answer: divText,
                question_uid: 'me',
                time: Date.now(),
                name: 'Myself'
            }
            dispatch(setChatAnswers(chatAnswer))
        } else {
            setTimeout(() => {
                askQuestion(e);
            }, 1000)
        }
    }

    async function handleContentEditable(e: any) {
        let divText = e.target.value;
        if (divText) {
            // setQuestion(divText)
            setTyped(divText)
            if (e.key === "Enter") {
                await askQuestion(e);
            }
        } else {
            setTyped('');
        }
    }

    const disableNewlines = async (event: any) => {
        const keyCode = event.keyCode || event.which

        if (keyCode === 13) {
            event.returnValue = false
            if (event.preventDefault) {
                event.preventDefault()
            }

            if (event.target.value && event.target.value !== '') {
                await askQuestion(event)
            }

        }
    }

    function pasteAsPlainText(event: any) {
        event.preventDefault()
        const text = event.clipboardData.getData('text/plain')
        document.execCommand('insertHTML', false, text)
    }

    const handleFocus = (event: any) => {
        event.target.placeholder = "";
        event.target.select();
    };

    function startSpeech() {
        //let audio = new Audio('/synth/assets/web/mp3/open.mp3');
        //audio.play();
        if (!speech) {
            setSpeech(true)
            SpeechRecognition.startListening({continuous: true})
        }
    }

    function stopSpeech() {
        //let audio = new Audio('/synth/assets/web/mp3/close.mp3');
        //audio.play();

        //closeModal();
        setTimeout(() => {
            setSpeech(false)
            SpeechRecognition.stopListening();
            setIsPaused(true);
        }, 500);

    }

    const stopGenerating = () => {
        dispatch(setAvatarMuted(true));
        dispatch(setAnswer(''));
        dispatch(setGenerating(''));
    }
    const sendExampleQn = (qn: string) => {
        askQuestion(qn);
    }
    const page = (window as any).page ? (window as any).page : 'profile';
    return (
        // <form className="input-form tc-addressbar-form" spellCheck="false" onSubmit={askQuestion}>
        <div className="question-bar" id='question-bar'>
            <div className="question-bar-container">
                {(chatAnswers.length === 0 && suggestedQuestions.length > 0) &&
                    <Example extraClass="question-bar-suggested-qn" sendExampleQn={sendExampleQn}/>
                }
                <div className="tc-txt-info txt-yellow">You Are In Conversation With {(window as any).name}'s Digital
                    Twin
                </div>
                <div className="tc-txt-info">The Following Discussion is Powered by Generative AI and Might Contain
                    Errors
                </div>
                {page === 'social' &&
                    <div className="tc-queston-bar-social-text">You are having a conversation with a digital twin
                        of {firstName}</div>
                }
                <div className={`input-wrapper ${(typed === '' && generating === '') ? 'disabled' : ''} `}>
                    {page !== 'social' &&
                        <input
                            ref={textareaRef}
                            value={typed}
                            data-tooltip-id="m-chat-input-left-icons-question" placeholder="Question?"
                            className="m-chat-message-input"
                            onChange={(e) => handleContentEditable(e)}
                            onKeyDown={(e) => disableNewlines(e)}
                            onPaste={(e) => pasteAsPlainText(e)}
                            onFocus={handleFocus}
                            onBlur={(e) => e.target.placeholder = "Question?"}
                        />
                    }
                    {page === 'social' &&
                        <input
                            ref={textareaRef}
                            value={typed}
                            data-tooltip-id="m-chat-input-left-icons-question"
                            className="m-chat-message-input"
                            onChange={(e) => handleContentEditable(e)}
                            onKeyDown={(e) => disableNewlines(e)}
                            onPaste={(e) => pasteAsPlainText(e)}
                            onFocus={handleFocus}
                        />
                    }
                    {generating !== '' ? <div className="send" onClick={stopGenerating}>
                            <a href="#">
                                <span></span>
                            </a>
                        </div> :
                        <div className="send" onClick={sendQuestion}>
                            <a href="#">
                                <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 6V18M12 6L7 11M12 6L17 11" stroke="#ffffff" strokeWidth="2"
                                          strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </a>
                        </div>}
                    <div className={!speech ? 'microphone' : 'tc-active-mic microphone'} onMouseDown={startSpeech}
                         onMouseUp={stopSpeech}>
                        <svg xmlns="http://www.w3.org/2000/svg" width={21} height={22} viewBox="0 0 21 22">
                            <g fill="#772d84" fillRule="evenodd">
                                <path
                                    d="M2 10.5v-7C2 1.57 3.57 0 5.5 0S9 1.57 9 3.5v7C9 12.43 7.43 14 5.5 14S2 12.43 2 10.5z"
                                    transform="translate(5 1)"/>
                                <path
                                    d="M10 7.5v3c0 2.482-2.019 4.5-4.5 4.5C3.018 15 1 12.982 1 10.5v-3C1 7.223.776 7 .5 7s-.5.223-.5.5v3c0 2.864 2.201 5.221 5 5.475V19H3.5c-.276 0-.5.224-.5.5s.224.5.5.5h4c.277 0 .5-.224.5-.5s-.223-.5-.5-.5H6v-3.025c2.799-.254 5-2.611 5-5.475v-3c0-.277-.223-.5-.5-.5s-.5.223-.5.5z"
                                    transform="translate(5 1)"/>
                            </g>
                        </svg>
                        <div className="rainbow-container">
                            <div className="green"/>
                            <div className="pink"/>
                            <div className="blue"/>
                        </div>
                    </div>
                    {typed === '' && page === 'social' &&
                        <div className="tc-question-bar-placeholder">Ask me anything...</div>
                    }
                </div>

            </div>


        </div>
        // </form>
    );
}
